export default __webpack_public_path__ + "images/8c65e279dd9474733cd375df4b398cf6.svg";